<template>
  <IQOS required :title="$t('integrations.iiko_connect.title')">
    <div class="mt-16" v-if="!isConnected">
      <BaseButton variant="secondary" color="v1-grey-10" size="md" @click="connect_modal = true">
        {{ $t('integrations.iiko_connect.connect_btn') }}
      </BaseButton>
    </div>
    <div v-else>
      <p class="iqos-comment mt-16 qrw-paragraph-md">
         {{ $t('integrations.iiko_connect.active') }} {{ cafe.iiko.connected_at | formatDatetime }}
      </p>
      <BaseButton
        variant="secondary"
        color="red-4"
        size="md"
        class="mt-16"
        @click="disconnect_modal = true"
      >
        {{ $t('integrations.iiko_connect.disconnect') }}
      </BaseButton>
    </div>

    <DangerConfirmModal
      @cancel="disconnect_modal = false"
      @confirm="disconnectIntegration"
      v-if="disconnect_modal"
    >
       {{ $t('integrations.iiko_connect.confirm_disconnect') }}
    </DangerConfirmModal>

    <IikoDisconectModal 
      @close="disconnecting = false"
      v-if="disconnecting"/>

    <IikoConnectionModal @close="connect_modal = false" v-if="connect_modal" />
  </IQOS>
</template>

<script>

import IikoDisconectModal from "@/components/integrations/IikoDisconnectModal.vue";
import IikoConnectionModal from "@/components/integrations/IikoConnectionModal.vue";

import IikoAPI from "@/api/iiko";

export default {
  data() {
    return {
      connect_modal: false,
      disconnect_modal: false,

      disconnecting: false
    };
  },
  components: {
    IikoConnectionModal,
    IikoDisconectModal,
  },
  methods: {
    disconnectIntegration() {
      IikoAPI.disconnect(this.cafe._id)
        .then((data) => {
          // this.$store.dispatch("fetchCafe");
          this.disconnecting = true;
          this.disconnect_modal = false;
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    isConnected() {
      return this.cafe.iiko && this.cafe.iiko.front_token;
    },
  },
};
</script>

<style scoped>
.ds-buttons {
  display: flex;
  justify-content: space-between;
}  

.ds-buttons a {
  text-decoration: none;
}
</style>